/**
 * 추가공간 옵저빙 목록 정렬 (표시·체크리스트·다음 액션).
 * API `additionalSpaceObserving` 배열 순서와 무관하게 아래 순서를 쓴다.
 *
 * 1. 사다리차 진입로(집 내부)
 * 2. 세대창고
 * 3. 계단
 * 4. 엘리베이터
 * 5. 사다리차 진입로(1층)
 *
 * 알 수 없는 spaceType은 맨 뒤로 보내고, 동일 순위·동일 미지정끼리는 API 순서를 유지한다.
 */
const ORDER_RANK = new Map<string, number>([
  ['LADDER_TRUCK_ENTRANCE', 0],
  ['RESIDENCE_STORAGE', 1],
  ['STAIRS', 2],
  ['STAIR', 2],
  ['ELEVATOR', 3],
  ['FIRST_FLOOR_TRUCK_ENTRANCE', 4],
]);

const UNKNOWN_RANK = 1000;

function rank(spaceType: string): number {
  return ORDER_RANK.get(spaceType) ?? UNKNOWN_RANK;
}

export function sortAdditionalSpaceObservingSessions<T extends { spaceType: string }>(
  sessions: T[]
): T[] {
  return sessions
    .map((session, originalIndex) => ({ session, originalIndex }))
    .sort((a, b) => {
      const ra = rank(a.session.spaceType);
      const rb = rank(b.session.spaceType);
      if (ra !== rb) return ra - rb;
      return a.originalIndex - b.originalIndex;
    })
    .map(({ session }) => session);
}
